import type { PersonaRole } from "@/store";

export interface RouteDestination {
  key: string;
  path: string;
  labelKey: string;
  /** Roles that may use this as a landing page. Empty = all roles. */
  allowedRoles?: PersonaRole[];
}

/**
 * All navigable destinations. Used by the nav rail, the preferences
 * route picker, and the DefaultRedirect component.
 */
export const ROUTE_DESTINATIONS: RouteDestination[] = [
  { key: "home", path: "/home", labelKey: "nav.home" },
  { key: "queue", path: "/queue", labelKey: "nav.myQueue" },
  {
    key: "team",
    path: "/team",
    labelKey: "nav.team",
    allowedRoles: ["team-leader", "executive-director"],
  },
  {
    key: "dashboard",
    path: "/dashboard",
    labelKey: "nav.dashboard",
    allowedRoles: ["team-leader", "executive-director"],
  },
  {
    key: "accounts",
    path: "/accounts",
    labelKey: "nav.accounts",
    allowedRoles: ["compliance-officer", "team-leader", "executive-director"],
  },
];

/**
 * Return route destinations available to a given role.
 */
export function getRoutesForRole(role: PersonaRole): RouteDestination[] {
  return ROUTE_DESTINATIONS.filter(
    (r) => !r.allowedRoles || r.allowedRoles.includes(role),
  );
}

/**
 * Check whether a path is a valid destination for the given role.
 */
export function isValidRouteForRole(path: string, role: PersonaRole): boolean {
  return getRoutesForRole(role).some((r) => r.path === path);
}
